import React, {Component} from "react";
import WhereToSell from './whereToSell';
import HowToPrice  from './howToPrice/howToPrice';
import Calculator  from './calculator/calculate';
import Experts     from './experts';

class ExpertsLayout extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0,0);
        }
    }

    render(){
        let main
        switch (this.props.router.location.pathname){
            case '/learn/where-to-sell':
                main = <WhereToSell/>; break;
            case '/learn/how-to-price':
                main = <HowToPrice/>; break;
            case '/learn/calculator':
                main = <Calculator/>; break;
            default:
                main = <Experts/>; break;
        }
        return main
    }
}

export default ExpertsLayout;
